<template>
  <div class="app-container">
    <CrudTable entity="ExactInstance" :columns="columns" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        'name',
        { field: 'serviceUrl', label: 'exactInstance.serviceUrl' },
        { field: 'serverName', label: 'exactInstance.serverName' }
      ]
    };
  }
};
</script>

<style scoped></style>
